require('./polyfill/object.js');
require('./polyfill/array.js');
require('./polyfill/string.js');
require('./polyfill/function.js');
require('./polyfill/console.js');
require('./polyfill/typedarray.js');
require('./polyfill/json.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/autobahn/lib/polyfill.js
// module id = 650
// module chunks = 0